import type {CandidateEvaluationAction} from 'src/action-creators/candidate-evaluation';
import type {CandidateEvaluationState} from 'src/types/candidate-evaluation';
import {getDefaultNodeScheduleState} from 'src/utils/node-schedule';
import {
  RECEIVE_CANDIDATE_EVALUATION_INFO,
  UPDATE_CANDIDATE_EVALUATION_INFO,
  UPDATE_NODE_SCHEDULE,
  RESET_CANDIDATE_EVALUATION_INFO,
} from 'src/action-creators/candidate-evaluation';


const initialState = {
  transcript: null,
  transcript_source: 'voice_ai_call',
  conversation_id: null,
  job_id: null,
  job_title: null,
  job_description: null,
  recipient_entity_id: null,
  resume: null,
  ...getDefaultNodeScheduleState({}),
} as const;

export default (
  state: CandidateEvaluationState = initialState,
  action: CandidateEvaluationAction,
): CandidateEvaluationState => {
  switch (action.type) {
    case RECEIVE_CANDIDATE_EVALUATION_INFO:
      return {
        ...state,
        ...action.payload,
      };
    case UPDATE_CANDIDATE_EVALUATION_INFO:
      return {
        ...state,
        ...action.payload,
      };
    case UPDATE_NODE_SCHEDULE:
      return {
        ...state,
        ...action.payload,
      };
    case RESET_CANDIDATE_EVALUATION_INFO:
      return {...initialState};
  }
  return state;
};
